export function updateManualAddressFields(value, index, state) {
  state.addressFields[index].value = value;
  const completeAddress = getCompleteAddress(state.addressFields);

  const addressValueObject = state.addressFields.reduce(
    (obj, item) => Object.assign(obj, assignAddressObject(item)),
    {}
  );

  state.field.value = completeAddress;
  state.field.valueObj = addressValueObject;
  state.field.addressValue = completeAddress;

  state.addressFields[index].isInvalid =
    !value ||
    (!isLettersAndSpaces(value) &&
      state.addressFields[index].name === 'locality')
      ? true
      : false;

  const invalidFields = state.addressFields.filter((item) => {
    return item.isInvalid === true || item.isInvalid === null;
  });

  if (state.addressFields[index].isInvalid || invalidFields.length > 0) {
    state.field.isInvalid = null;
    state.field.value = '';
    state.field.valueObj = '';
    state.field.addressValue = '';
  }
}

function getCompleteAddress(addressFields) {
  return addressFields.reduce(
    (previous, current) =>
      (previous.value ? previous.value : previous) +
      ' ' +
      (current.name === 'regionCode' ? current.code : current.value)
  );
}

function assignAddressObject(item) {
  if (item.name === 'addressLines') return { [item.name]: [item.value] };
  if (item.name === 'regionCode') return { [item.name]: item.code };
  return { [item.name]: item.value };
}

function isLettersAndSpaces(str) {
  return /^[A-Za-z\s]*$/.test(str);
}
